import { ModalProps } from "@kernel/react-ui-kit";
import { IStack, Stack } from "@kernel/utils";
import { ReactNode } from "react";

export type DialogSizeType = "sm" | "lg" | "xl";
export type FullscreenDialogType =
  | undefined
  | true
  | string
  | "sm-down"
  | "md-down"
  | "lg-down"
  | "xl-down"
  | "xxl-down";
export interface DialogState {
  open: boolean;
  size?: "sm" | "lg" | "xl";
  fullscreen?: FullscreenDialogType;
  props?: Omit<ModalProps, "bakdrop" | "children">;
  component: ReactNode | null;
}

export interface GlobalDialogState {
  dialogs: IStack<DialogState>;
}

export const defaultGlobalDialogState: GlobalDialogState = {
  dialogs: new Stack<DialogState>()
};
